import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { ReportDto } from "../types/report";

export default function serviceLevelsReportReducer(
  state: ReportDto = initialState.serviceLevelsReport,
  action: AnyAction
): ReportDto {
  switch (action.type) {
    case internalActionKeys.GET_SERVICE_LEVELS_REPORT_SUCCESS:
      return action.report;
    default:
      return state;
  }
}
